import { MarkdownContent } from "components/common/MarkdownContent";
import sanitizeHtml from "sanitize-html";

const COMMUNICATION_BODY_ALLOWED_TAGS = [
  "p",
  "br",
  "a",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
  "div",
  "span",
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
] as const;

type CommunicationBodyProps = {
  bodyHtml?: string | null;
  bodyText?: string | null;
  className?: string;
};

/** Renders outreach communication body: sanitized HTML when present, otherwise GFM markdown. */
export function CommunicationBody({ bodyHtml, bodyText, className }: CommunicationBodyProps) {
  const html = bodyHtml?.trim();
  if (html) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(html, {
            allowedTags: [...COMMUNICATION_BODY_ALLOWED_TAGS],
          }),
        }}
      />
    );
  }

  const text = bodyText?.trim();
  if (!text) return null;

  return (
    <div className={className}>
      <MarkdownContent>{text}</MarkdownContent>
    </div>
  );
}
